<template>
  <div class="admin-page">
    <div class="admin-header">
      <h1>Foot 360 Consultations</h1>
      <router-link to="/pointe/admin/consultations/new" class="btn-primary">+ New Consultation</router-link>
    </div>

    <div class="admin-nav">
      <router-link to="/pointe/admin/cohorts">Cohorts</router-link>
      <router-link to="/pointe/admin/applications">Applications</router-link>
      <router-link to="/pointe/admin/criteria">Criteria</router-link>
    </div>

    <div class="filters">
      <input v-model="searchQuery" type="text" class="form-input" placeholder="Search by dancer name or email…" />
    </div>

    <div v-if="loading" class="loading-wrap">
      <v-progress-circular indeterminate color="#1a1a1a"></v-progress-circular>
    </div>

    <div v-else-if="filtered.length === 0" class="empty-state">
      <p>No consultations found.</p>
    </div>

    <div v-else class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Dancer</th>
            <th>Date</th>
            <th>Status</th>
            <th>Follow-ups Remaining</th>
            <th>Linked Apps</th>
            <th>Historical</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="c in filtered" :key="c.id">
            <td>
              <div class="dancer-name">{{ c.dancerName }}</div>
              <div class="dancer-email">{{ c.dancerEmail }}</div>
            </td>
            <td>{{ formatDate(c.consultationDate) }}</td>
            <td>
              <span class="status-badge" :class="c.status">{{ c.status }}</span>
            </td>
            <td class="followup-cell">
              {{ c.followUpsRemaining }}/{{ (c.followUpsRemaining || 0) + (c.followUpsUsed || 0) }}
            </td>
            <td>{{ (c.linkedApplicationIds || []).length || '—' }}</td>
            <td>{{ c.isHistorical ? 'Yes' : '—' }}</td>
            <td>
              <router-link :to="'/pointe/admin/consultations/new?edit=' + c.id" class="btn-edit">Edit</router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase'

export default {
  data () {
    return {
      consultations: [],
      loading: true,
      searchQuery: ''
    }
  },
  computed: {
    filtered () {
      if (!this.searchQuery) return this.consultations
      const q = this.searchQuery.toLowerCase()
      return this.consultations.filter(c =>
        (c.dancerName || '').toLowerCase().includes(q) ||
        (c.dancerEmail || '').toLowerCase().includes(q)
      )
    }
  },
  async created () {
    const snap = await db.collection('pointe-consultations').orderBy('createdAt', 'desc').get()
    this.consultations = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    this.loading = false
  },
  methods: {
    formatDate (ts) {
      if (!ts) return '—'
      const d = ts.toDate ? ts.toDate() : new Date(ts)
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    }
  }
}
</script>

<style scoped>
.admin-page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px 24px;
  font-family: 'Fanwood Text', Georgia, serif;
}

.admin-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.admin-header h1 {
  font-family: 'Quattrocento', Georgia, serif;
  font-size: 28px;
  color: #1a1a1a;
  margin: 0;
}

.admin-nav {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e8e5e1;
  padding-bottom: 12px;
}

.admin-nav a { font-size: 14px; color: #666; text-decoration: none; }
.admin-nav a:hover { color: #1a1a1a; }

.filters { margin-bottom: 20px; }

.form-input {
  width: 340px;
  border: 1px solid #e8e5e1;
  padding: 9px 12px;
  font-family: 'Fanwood Text', Georgia, serif;
  font-size: 14px;
  border-radius: 2px;
  box-sizing: border-box;
  color: #1a1a1a;
  background: #fff;
}

.form-input:focus { outline: none; border-color: #1a1a1a; }

.loading-wrap { padding: 40px; text-align: center; }
.empty-state { padding: 40px; text-align: center; color: #888; }

.table-wrap { overflow-x: auto; }

table { width: 100%; border-collapse: collapse; font-size: 14px; }

th {
  text-align: left;
  padding: 10px 14px;
  border-bottom: 2px solid #e8e5e1;
  font-family: 'Quattrocento', Georgia, serif;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #888;
}

td {
  padding: 12px 14px;
  border-bottom: 1px solid #f0eeec;
  color: #1a1a1a;
  vertical-align: middle;
}

.dancer-name { font-weight: 600; }
.dancer-email { font-size: 12px; color: #888; }

.followup-cell { font-weight: 600; }

.status-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .04em;
}

.status-badge.draft { background: #f5f5f5; color: #616161; }
.status-badge.complete { background: #e8f5e9; color: #2e7d32; }

.btn-primary {
  background: #1a1a1a;
  color: #fff;
  border: none;
  padding: 10px 20px;
  font-family: 'Fanwood Text', Georgia, serif;
  font-size: 14px;
  cursor: pointer;
  border-radius: 2px;
  text-decoration: none;
  display: inline-block;
}

.btn-primary:hover { background: #333; }

.btn-edit {
  background: none;
  border: 1px solid #e8e5e1;
  padding: 5px 12px;
  font-size: 13px;
  font-family: 'Fanwood Text', Georgia, serif;
  cursor: pointer;
  border-radius: 2px;
  color: #1a1a1a;
  text-decoration: none;
  display: inline-block;
}

.btn-edit:hover { border-color: #1a1a1a; }
</style>
